module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kucuntihuo"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "daohang"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "color": "#2d8cf0",
      "font-family": "'微软雅黑'"
    },
    on: {
      "click": _vm.tiaozhuan
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-home"
    }
  }), _vm._v(_vm._s(_vm.languages.shouye))], 1), _vm._v(">\n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "font-family": "'微软雅黑'"
    }
  }, [_vm._v(_vm._s(_vm.languages.tihuoshenqing))])]), _vm._v(" "), _c('div', {
    staticClass: "iptc"
  }, [_c('div', {
    staticClass: "iptlis"
  }, [_c('Icon', {
    staticClass: "ico",
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "iptli",
    attrs: {
      "placeholder": _vm.languages.chaxunqingdianjiwo,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal1 = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "numEve"
  }, [_c('div', {
    staticClass: "numlitter"
  }, [_vm._v(_vm._s(_vm.languages.gong) + _vm._s(_vm.numnum) + _vm._s(_vm.languages.tiao))])])], 1)])]), _vm._v(" "), _c('modal', {
    staticClass: "serchlist",
    attrs: {
      "width": "86%",
      "styles": {
        top: '60px',
        left: '100px',
        background: 'red'
      }
    },
    model: {
      value: (_vm.modal1),
      callback: function($$v) {
        _vm.modal1 = $$v
      },
      expression: "modal1"
    }
  }, [_c('div', {
    staticClass: "pz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.languages.qingxuanze,
      "plae": "",
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numpinzhong),
      callback: function($$v) {
        _vm.numpinzhong = $$v
      },
      expression: "numpinzhong"
    }
  }, _vm._l((_vm.selectDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "pinzhongs"
  }, [_vm._v(_vm._s(_vm.languages.pinzhong))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ph"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.languages.qingxuanze,
      "plae": "",
      "type": "text",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.numpaihao),
      callback: function($$v) {
        _vm.numpaihao = $$v
      },
      expression: "numpaihao"
    }
  }, _vm._l((_vm.shopDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "paihaos"
  }, [_vm._v(_vm._s(_vm.languages.paihao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "hou"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numhou),
      callback: function($$v) {
        _vm.numhou = $$v
      },
      expression: "numhou"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hous"
  }, [_vm._v(_vm._s(_vm.languages.hou))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kuan"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numkuan),
      callback: function($$v) {
        _vm.numkuan = $$v
      },
      expression: "numkuan"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kuans"
  }, [_vm._v(_vm._s(_vm.languages.kuan))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chang"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numchang),
      callback: function($$v) {
        _vm.numchang = $$v
      },
      expression: "numchang"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "changs"
  }, [_vm._v(_vm._s(_vm.languages.chang))])], 1), _vm._v(" "), _c('div', {
    staticClass: "ck"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.languages.qingxuanze,
      "plae": "",
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numcangku),
      callback: function($$v) {
        _vm.numcangku = $$v
      },
      expression: "numcangku"
    }
  }, _vm._l((_vm.wareDatta), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "cangkus"
  }, [_vm._v(_vm._s(_vm.languages.cangku))])], 1), _vm._v(" "), _c('div', {
    staticClass: "kunb"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.numkunbaohao),
      callback: function($$v) {
        _vm.numkunbaohao = $$v
      },
      expression: "numkunbaohao"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "kunbaohaos"
  }, [_vm._v(_vm._s(_vm.languages.kunbaohao))])], 1), _vm._v(" "), _c('div', {
    staticClass: "chxz"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": _vm.languages.qingxuanze,
      "plae": "",
      "name": "",
      "id": "",
      "clearable": ""
    },
    model: {
      value: (_vm.cunhuo),
      callback: function($$v) {
        _vm.cunhuo = $$v
      },
      expression: "cunhuo"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })), _vm._v(" "), _c('span', {
    staticClass: "cunhuo"
  }, [_vm._v(_vm._s(_vm.languages.yewuleixing))])], 1), _vm._v(" "), _c('div', {
    staticClass: "muj"
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.nummujuanhao),
      callback: function($$v) {
        _vm.nummujuanhao = $$v
      },
      expression: "nummujuanhao"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mujuanhaos"
  }, [_vm._v(_vm._s(_vm.languages.mujuanhao))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(249,249,249)"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "chaxun",
    on: {
      "click": function($event) {
        _vm.chaxun()
      }
    }
  }, [_vm._v(_vm._s(_vm.languages.chaxun))]), _vm._v(" "), _c('div', {
    staticClass: "chongzhi",
    on: {
      "click": function($event) {
        _vm.chongzhis()
      }
    }
  }, [_vm._v(_vm._s(_vm.languages.chongzhi))])])]), _vm._v(" "), _c('Scroll', {
    attrs: {
      "on-reach-bottom": _vm.handleReachBottom,
      "height": "600",
      "distance-to-edge": [-20, 0]
    }
  }, [_c('div', {
    staticClass: "productrow"
  }, [_c('input', {
    staticClass: "Partiallyproduct",
    class: {
      backcol: _vm.BackCol
    },
    attrs: {
      "type": "button",
      "value": _vm.languages.chengpin,
      "span": "12"
    },
    on: {
      "click": function($event) {
        _vm.Tabswitch1(1)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "material",
    class: {
      backcol2: _vm.BackCol2
    },
    attrs: {
      "type": "button",
      "value": _vm.languages.yuanliao,
      "span": "12"
    },
    on: {
      "click": _vm.Tabswitch2
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "prolist"
  }, [(_vm.flag1) ? _c('div', {
    staticClass: "Partiallyproductlist"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.part_list,
      "data": _vm.partproduct
    },
    on: {
      "on-selection-change": _vm.getNews
    }
  }), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jiazai),
      expression: "jiazai"
    }],
    staticClass: "demo-spin-col",
    attrs: {
      "span": "24"
    }
  }, [_c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "load-c",
      "size": "18"
    }
  })], 1), _c('div', [_vm._v("Loading")]), _vm._v(" "), _c('p')])], 1), _vm._v(" "), _c('div', {
    staticClass: "jiazai"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moredata),
      expression: "moredata"
    }],
    staticClass: "add_more_data_btn"
  }, [_vm._v("\n                      " + _vm._s(_vm.languages.jiazaiwanbi) + "\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.flag2) ? _c('div', {
    staticClass: "materiallist"
  }, [_c('Table', {
    staticClass: "yuanliao",
    attrs: {
      "border": "",
      "columns": _vm.mater_list,
      "data": _vm.materia
    },
    on: {
      "on-selection-change": _vm.getNews
    }
  }), _vm._v(" "), _c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.jiazai2),
      expression: "jiazai2"
    }],
    staticClass: "demo-spin-col",
    attrs: {
      "span": "24"
    }
  }, [_c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "load-c",
      "size": "18"
    }
  }), _vm._v(" "), _c('div', [_vm._v("Loading")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "zaijia",
    on: {
      "click": function($event) {
        _vm.addmeautwo(1)
      }
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moredatas),
      expression: "moredatas"
    }],
    staticClass: "add_more_data_btn"
  }, [_vm._v("\n                          " + _vm._s(_vm.languages.jiazaiwanbi) + "\n                        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sub_lit),
      expression: "sub_lit"
    }],
    staticClass: "subplan"
  }, [_c('div', {
    staticClass: "table",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_vm._v(_vm._s(_vm.languages.gouwuche)), _c('span', {
    on: {
      "click": _vm.subplan_list_lit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close-outline"
    }
  }), _vm._v(_vm._s(_vm.languages.guanbi))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tablecontant"
  }, [_c('div', {
    staticClass: "tablecontantBot"
  }, [_c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.languages.shouhuokehu))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.languages.cangku))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.languages.kuwei))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.languages.kunbaohao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.pinzhong))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v(_vm._s(_vm.languages.paihao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.guige))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.zhongliang))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.neiwaiban))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.languages.juanjing))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.rukuriqi))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.languages.mujuankunbaohao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.mujuanguige))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.languages.mujuanzhongliang))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v(_vm._s(_vm.languages.jianshu))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.caozuo))])]), _vm._v(" "), _vm._l((_vm.newCardObj), function(x, index) {
    return _c('div', {
      key: index
    }, [_vm._l((x.value.group), function(y, indexs) {
      return _c('div', {
        key: indexs,
        staticClass: "tablemain"
      }, [_c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(y.customerName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "7%"
        }
      }, [_vm._v(_vm._s(y.warehouseName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "9%"
        }
      }, [_vm._v(_vm._s(y.locationName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "9%"
        }
      }, [_vm._v(_vm._s(y.serialCode))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.categoryCode))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(y.shopsign))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.specification))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.weight))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.exposedName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(y.rollPath))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.stockInDate))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(y.reelNo))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.rawPieceSpecdesc))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(y.rawPrimaryQty))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "3%"
        }
      }, [_vm._v(_vm._s(y.secondQty))]), _vm._v(" "), _c('span', {
        staticClass: "caozuo",
        staticStyle: {
          "width": "4%"
        },
        on: {
          "click": function($event) {
            _vm.removeCarNews(y.serialCode)
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": "ios-undo"
        }
      })], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "tablemains"
    }, [_c('span', {
      staticClass: "carhous",
      staticStyle: {
        "width": "26%"
      }
    }, [_vm._v(_vm._s(x.key))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "24%"
      }
    }, [_vm._v(_vm._s(_vm.languages.cangkuheji) + "：" + _vm._s(x.value.sum))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(_vm.languages.kunbaoshuliang))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos",
      staticStyle: {
        "width": "12%",
        "border-left": "1px solid #ddd"
      }
    }, [_vm._v(_vm._s(x.value.serialNumber))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(_vm.languages.shuliang))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos",
      staticStyle: {
        "width": "13%",
        "border-left": "1px solid #ddd"
      }
    }, [_vm._v(_vm._s(x.value.number))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos"
    })])], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "tablemainadd"
  }, [_c('span', {
    staticClass: "tablemainadds"
  }, [_vm._v(_vm._s(_vm.languages.heji))]), _vm._v(" "), _c('span', {
    staticClass: "tablemainadds"
  }, [_vm._v(_vm._s(_vm.addnum2.sum))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tijiaoanniu"
  }, [_c('button', {
    staticClass: "tijiaoButton",
    on: {
      "click": function($event) {
        _vm.addTitleshow(1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload"
    }
  }), _vm._v(_vm._s(_vm.languages.tijiao))], 1), _vm._v(" "), _c('button', {
    staticClass: "tijiaoButton",
    on: {
      "click": function($event) {
        _vm.reset(_vm.newCardObj)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash"
    }
  }), _vm._v(_vm._s(_vm.languages.qingkong))], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sub_lit2),
      expression: "sub_lit2"
    }],
    staticClass: "subplan"
  }, [_c('div', {
    staticClass: "table",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_vm._v(_vm._s(_vm.languages.tihuojihua)), _c('span', {
    on: {
      "click": _vm.tihuoJihua
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close-outline"
    }
  }), _vm._v(_vm._s(_vm.languages.guanbi))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tablecontant"
  }, [_c('div', {
    staticClass: "tablecontantBot"
  }, [_c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.shouhuokehu))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.cangku))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.kuwei))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v(_vm._s(_vm.languages.kunbaohao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.pinzhong))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.languages.paihao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.guige))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.languages.zhongliang))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.neiwaiban))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.languages.juanjing))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.rukuriqi))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.languages.mujuankunbaohao))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.mujuanguige))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.mujuanzhongliang))]), _vm._v(" "), _c('span', {
    staticClass: "titcon",
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.languages.jianshu))]), _vm._v(" "), _c('span', {
    staticClass: "titcon"
  }, [_vm._v(_vm._s(_vm.languages.caozuo))])]), _vm._v(" "), _vm._l((_vm.newCardObj2), function(x, index) {
    return _c('div', {
      key: index
    }, [_vm._l((x.value.group), function(y, indexs) {
      return _c('div', {
        key: indexs,
        staticClass: "tablemain"
      }, [_c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.customerName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.warehouseName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.locationName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "9%"
        }
      }, [_vm._v(_vm._s(y.serialCode))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.categoryCode))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(y.shopsign))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.specification))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "4%"
        }
      }, [_vm._v(_vm._s(y.weight))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.exposedName))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(y.rollPath))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.stockInDate))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(y.reelNo))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.rawPieceSpecdesc))]), _vm._v(" "), _c('span', {
        staticClass: "guige"
      }, [_vm._v(_vm._s(y.rawPrimaryQty))]), _vm._v(" "), _c('span', {
        staticClass: "guige",
        staticStyle: {
          "width": "5%"
        }
      }, [_vm._v(_vm._s(y.secondQty))]), _vm._v(" "), _c('span', {
        staticClass: "caozuo",
        on: {
          "click": function($event) {
            _vm.removeCarNewss(y.serialCode)
          }
        }
      }, [_c('Icon', {
        attrs: {
          "type": "ios-undo"
        }
      })], 1)])
    }), _vm._v(" "), _c('div', {
      staticClass: "tablemains"
    }, [_c('span', {
      staticClass: "carhous",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(x.key))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(_vm.languages.cangkuheji) + "：" + _vm._s(x.value.sum))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(_vm.languages.kunbaoshuliang))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos",
      staticStyle: {
        "width": "12%",
        "border-left": "1px solid #ddd"
      }
    }, [_vm._v(_vm._s(x.value.serialNumber))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs",
      staticStyle: {
        "width": "14%"
      }
    }, [_vm._v(_vm._s(_vm.languages.shuliang))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos",
      staticStyle: {
        "width": "12%",
        "border-left": "1px solid #ddd"
      }
    }, [_vm._v(_vm._s(x.value.number))])])], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "tablemainadd"
  }, [_c('span', {
    staticClass: "tablemainadds"
  }, [_vm._v(_vm._s(_vm.languages.heji))]), _vm._v(" "), _c('span', {
    staticClass: "tablemainadds"
  }, [_vm._v(_vm._s(_vm.addnum3.sum))])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tijiaoanniu"
  }, [_c('button', {
    staticClass: "tijiaoButton",
    on: {
      "click": _vm.addTit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload"
    }
  }), _vm._v(_vm._s(_vm.languages.tijiao))], 1), _vm._v(" "), _c('button', {
    staticClass: "tijiaoButton",
    on: {
      "click": function($event) {
        _vm.resets(_vm.newCardObj2)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash"
    }
  }), _vm._v(_vm._s(_vm.languages.qingkong))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bootBanner"
  }, [_c('p', {
    staticClass: "liang"
  }, [_c('span', [_c('span', {
    staticClass: "tihuoButton",
    on: {
      "click": _vm.tihuoJihua
    }
  }, [_c('Icon', {
    attrs: {
      "type": "calendar"
    }
  }), _vm._v(_vm._s(_vm.languages.tihuojihua))], 1)]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "shopButton",
    on: {
      "click": _vm.subplan_list_lit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cart"
    }
  }), _vm._v(_vm._s(_vm.languages.gouwuche))], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "showTabSecout"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTabSec),
      expression: "showTabSec"
    }],
    staticClass: "subpage"
  }, [_c('p', {
    staticClass: "titlefirst"
  }, [_c('span', {
    staticClass: "return",
    on: {
      "click": _vm.fanhui
    }
  }, [_vm._v(_vm._s(_vm.languages.fanhui))]), _vm._v(" "), _c('span', {
    staticClass: "returntitle"
  }, [_vm._v(_vm._s(_vm.languages.tihuoshenqing))])]), _vm._v(" "), _c('div', {
    staticClass: "titSecond"
  }, [_c('Row', {
    staticClass: "iptSerch"
  }, [_c('Col', {
    staticClass: "ipt1",
    attrs: {
      "span": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chengyunshang),
      expression: "chengyunshang"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chengyunshang)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chengyunshang = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cys"
  }, [_vm._v(_vm._s(_vm.languages.chengyunshang))])]), _vm._v(" "), _c('Col', {
    staticClass: "ipt1",
    attrs: {
      "span": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chepaihao),
      expression: "chepaihao"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chepaihao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chepaihao = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cph"
  }, [_vm._v(_vm._s(_vm.languages.chepaihao))])]), _vm._v(" "), _c('Col', {
    staticClass: "ipt1",
    attrs: {
      "span": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beizhu),
      expression: "beizhu"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.beizhu)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beizhu = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bz"
  }, [_vm._v(_vm._s(_vm.languages.beizhu))])]), _vm._v(" "), _c('Col', {
    staticClass: "ipt1",
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.languages.shenqingriqi) + "：" + _vm._s(this.newDate))])])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnsgouwuche,
      "data": _vm.data1
    }
  }), _vm._v(" "), _vm._l((_vm.newCardObj), function(x, index) {
    return _c('div', {
      key: index
    }, [_c('p', {
      staticClass: "tableP"
    }), _c('div', {
      staticClass: "tableadd"
    }, [_c('span', {
      staticClass: "guiges"
    }, [_vm._v(_vm._s(_vm.languages.hejizongzhongliang) + "：")]), _vm._v(" "), _c('span', {
      staticClass: "carhous"
    }, [_vm._v(_vm._s(_vm.languages.cangku) + ":" + _vm._s(x.key))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs"
    }, [_c('p', [_vm._v(_vm._s(x.value.sum))]), _vm._v("吨")]), _vm._v(" "), _c('span', {
      staticClass: "caozuos"
    })]), _vm._v(" "), _c('p')])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "tjthsqan"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.gouwuchequanbus()
      }
    }
  }, [_vm._v(_vm._s(_vm.languages.tijiao))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "showTabSecout"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTabSectim),
      expression: "showTabSectim"
    }],
    staticClass: "subpage"
  }, [_c('p', {
    staticClass: "titlefirst"
  }, [_c('span', {
    staticClass: "return",
    on: {
      "click": _vm.fanhui
    }
  }, [_c('Icon', {
    attrs: {
      "type": "reply"
    }
  }), _vm._v(_vm._s(_vm.languages.fanhui))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "titSecond",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "titleSecs",
    staticStyle: {
      "font-size": "25px",
      "color": "black",
      "height": "80px",
      "position": "absolute",
      "left": "50%",
      "margin-left": "-50px",
      "top": "-100px",
      "border-top": "none"
    }
  }, [_vm._v(_vm._s(_vm.languages.tihuojihua))]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns1,
      "data": _vm.subplanNumJihua
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tableP"
  }), _vm._l((_vm.newCardObj2), function(x, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "tableadd"
    }, [_c('span', {
      staticClass: "carhous"
    }, [_vm._v(_vm._s(x.key))]), _vm._v(" "), _c('span', {
      staticClass: "guiges"
    }, [_vm._v(_vm._s(_vm.languages.heji))]), _vm._v(" "), _c('span', {
      staticClass: "zhongs"
    }, [_vm._v(_vm._s(x.value.sum))]), _vm._v(" "), _c('span', {
      staticClass: "caozuos"
    })])])
  }), _vm._v(" "), _c('p')], 2), _vm._v(" "), _c('p', {
    staticClass: "tjthsqan"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.tjthsqanspa()
      }
    }
  }, [_vm._v(_vm._s(_vm.languages.tijiao))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dcc2b46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/delivery.vue
// module id = 902
// module chunks = 1